export function emitNavRefresh() {
  window.dispatchEvent(new Event("NAV_REFRESH"));
}
